export default __webpack_public_path__ + "static/media/habano2.7cf8d694.png";